namespace Matrix.Dashboards {
    export interface WidgetTypeItem {
        Key?: string;
        Name?: string;
        Cols?: number;
        Rows?: number;
        Icon?: string;
        ScriptType?: string;
        Options?: Serenity.PropertyItem[];
    }
}
